export default from './Recipient';



// WEBPACK FOOTER //
// ./src/elements/recipient/index.jsx